import { useMutation } from '@tanstack/react-query';
import { updateServiceIntakeQuestions } from '../../services/business';
import useUser from '../global/useUser';

interface Options {
  onSuccess?: () => void | Promise<void>;
  onError?: () => void | Promise<void>;
}

function useUpdateServiceIntakeQuestions({ onSuccess, onError }: Options = {}) {
  const { user } = useUser();

  const businessId = user?.business?.id;

  return useMutation({
    mutationFn: async ({
      serviceId,
      questions,
    }: {
      serviceId: number;
      questions: { questionId: string; enabled: boolean }[];
    }) => {
      if (!businessId) throw new Error('Invalid parameters');
      return updateServiceIntakeQuestions(businessId, serviceId, questions);
    },
    onSuccess,
    onError,
  });
}

export default useUpdateServiceIntakeQuestions;
